import React from 'react'
import { Route, Routes } from 'react-router-dom'

import AllTags from '../tags/AllTags'

const TagsRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/all-tag" element={<AllTags />} />
            </Routes>
        </>
    )
}

export default TagsRoutes;